import { c as _c } from "react/compiler-runtime";
import { Box } from "@chakra-ui/react";
import CardHazard from "./card-hazard";
import { Hazards } from "../data/data";
import { CardContainer } from "./card-container";
import { Dispatch, SetStateAction } from "react";
import { LayerToggleObjProps } from "./address-mapper";
type HazardData = {
  softStory?: any;
  tsunami?: any;
  liquefaction?: any;
};
const ReportHazards = t0 => {
  const $ = _c(8);
  const {
    addressHazardData,
    isHazardDataLoading,
    toggledStates,
    setToggledStates,
    setLayerToggleObj
  } = t0;
  let t1;
  if ($[0] !== addressHazardData || $[1] !== isHazardDataLoading || $[2] !== setLayerToggleObj || $[3] !== setToggledStates || $[4] !== toggledStates) {
    t1 = Hazards.map(hazard => <CardHazard key={hazard.id} hazard={hazard} hazardData={addressHazardData?.[hazard.name as keyof HazardData] ?? undefined} showData={hazard.name in addressHazardData ? true : false} isHazardDataLoading={isHazardDataLoading} toggledStates={toggledStates} setToggledStates={setToggledStates} setLayerToggleObj={setLayerToggleObj} />);
    $[0] = addressHazardData;
    $[1] = isHazardDataLoading;
    $[2] = setLayerToggleObj;
    $[3] = setToggledStates;
    $[4] = toggledStates;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <Box><CardContainer>{t1}</CardContainer></Box>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default ReportHazards;